import * as systemActions from './../actions/system.actions';
import { initialSystemState, ISystemState } from './../../state/system.state';

export function SystemReducer(state = initialSystemState, action: systemActions.SystemActions): ISystemState {
    switch (action.type) {
        case systemActions.UPDATE_STATUS:
            return {
                ...state,
                status: action.payload
            };
        case systemActions.CLEAR_SYSTEM:
            return initialSystemState;
        default:
            return state;
    }
}
